import { byValue, ingresosNetos, sucursales } from "@/config/constants";

describe("sucursales tests", () => {
  it("should have at least one sucursal", () => {
    expect(sucursales.length).toBeGreaterThan(0);
  });

  it("should have unique id for each sucursal", () => {
    const ids = sucursales.map(sucursal => sucursal.idSucursal);
    const uniqueIds = [...new Set(ids)];
    expect(uniqueIds.length).toBe(ids.length);
  });

  it("deberia retornar null cuando no se encuentra el valor buscado", () => {
    expect(byValue("500", ingresosNetos)).toEqual(null);
  });

  it("deberia retornar null cuando no se encuentra la coleccion", () => {
    const ingresosBrutos = [];

    expect(byValue("500", ingresosBrutos)).toEqual(null);
  });

  it("deberia retornar el objeto cuando se encuentra en la coleccion", () => {
    expect(byValue("4500", ingresosNetos)).not.toBeNull();
  });
});
